// @atlas/contracts — a `currency-rates` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
/** Egy idősoros árfolyam-sor (`platform.currency_rates`). A `rate` Decimal-string (soha float). */
export const CurrencyRateRowSchema = z.object({
    baseCurrency: z.string(),
    quoteCurrency: z.string(),
    rateDate: z.string(),
    rate: z.string(),
    source: z.string().nullable(),
});
/** Az árfolyam-lista szűrője (base/quote — ISO-3 formátum-whitelist). */
export const CurrencyRateListQuerySchema = z.object({
    base: z
        .string()
        .regex(/^[A-Z]{3}$/, 'ISO-3 deviza-kód (pl. EUR)')
        .optional(),
    quote: z
        .string()
        .regex(/^[A-Z]{3}$/, 'ISO-3 deviza-kód (pl. HUF)')
        .optional(),
});
/**
 * Manuális havi árfolyam felvitele/frissítése (a UsageDataChecker szűrősávjából). A `rateDate` a hó 1-je
 * (`YYYY-MM-01`); a BFF a `source`-t mindig `manual`-ra állítja. Csak EUR/USD → HUF (a legacy manuális
 * árfolyam-igény). Odin-oldalon billing-írás (`write:all:billing`) VAGY `platform:admin` kell (403 egyik
 * nélkül sem — a UI-n is kapuzva).
 */
export const CurrencyRateUpsertBodySchema = z.object({
    baseCurrency: z.enum(['EUR', 'USD']),
    quoteCurrency: z.literal('HUF'),
    rateDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD formátum kötelező'),
    rate: z
        .string()
        .regex(/^\d{1,10}(\.\d{1,8})?$/, 'Érvénytelen árfolyam (numerikus, max 8 tizedes).'),
});
/**
 * Egy manuális havi árfolyam TÖRLÉSE — a természetes kulcs (base/quote/date) az útvonalban.
 *
 * MIÉRT KELL: a kolléga elírhatja a hónap kurzusát, és eddig csak FELÜLÍRNI tudta (a törlés hiányzott az
 * Odin API-ból is — most `DELETE /v1/currency-rates/:base/:quote/:date`). A törlés HARD és IDEMPOTENS: nem
 * létező soron `{ deleted: 0 }`, mert a hívó a VÉGÁLLAPOTOT kéri, nem az eseményt.
 */
export const CurrencyRateDeleteParamsSchema = z.object({
    base: z.enum(['EUR', 'USD']),
    quote: z.literal('HUF'),
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD formátum kötelező'),
});
//# sourceMappingURL=schemas.js.map